import axios from "axios"
import { Dispatch } from "../store.config"

export interface VatRate {
  id: number
  rate: string
}

export interface VatRatesOptions {
  value: string
  label: string
}

export interface VatRatesState {
  vatRatesStatus: "IDLE" | "LOADING" | "SUCCESS" | "ERROR"
  vatRates: VatRate[]
  vatRatesOptions: VatRatesOptions[]
}

export interface VatRatesResponse {
  vat_rates: VatRate[]
}

const enum VatRatesActionsEnum {
  GET_COMPANY_VAT_RATES_ATTEMPT = "VAT_RATES/getCompanyVatRatesAttempt",
  GET_COMPANY_VAT_RATES_SUCCESS = "VAT_RATES/getCompanyVatRatesSuccess",
  GET_COMPANY_VAT_RATES_ERROR = "VAT_RATES/getCompanyVatRatesError",
  GET_FIDUCIARY_VAT_RATES_ATTEMPT = "VAT_RATES/getFiduciaryyVatRatesAttempt",
  GET_FIDUCIARY_VAT_RATES_SUCCESS = "VAT_RATES/getFiduciaryyVatRatesSuccess",
  GET_FIDUCIARY_VAT_RATES_ERROR = "VAT_RATES/getFiduciaryyVatRatesError",
}

export const getCompanyVatRatesAttemptAction = () =>
  ({ type: VatRatesActionsEnum.GET_COMPANY_VAT_RATES_ATTEMPT } as const)
export const getCompanyVatRatesSuccessAction = (vatRates: VatRate[]) =>
  ({
    type: VatRatesActionsEnum.GET_COMPANY_VAT_RATES_SUCCESS,
    vatRates,
  } as const)
export const getCompanyVatRatesErrorAction = () =>
  ({ type: VatRatesActionsEnum.GET_COMPANY_VAT_RATES_ERROR } as const)

export const getFiduciaryVatRatesAttemptAction = () =>
  ({ type: VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_ATTEMPT } as const)
export const getFiduciaryVatRatesSuccessAction = (vatRates: VatRate[]) =>
  ({
    type: VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_SUCCESS,
    vatRates,
  } as const)
export const getFiduciaryVatRatesErrorAction = () =>
  ({ type: VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_ERROR } as const)

type VatRatesActionType = ReturnType<
  | typeof getCompanyVatRatesAttemptAction
  | typeof getCompanyVatRatesSuccessAction
  | typeof getCompanyVatRatesErrorAction
  | typeof getFiduciaryVatRatesAttemptAction
  | typeof getFiduciaryVatRatesSuccessAction
  | typeof getFiduciaryVatRatesErrorAction
>

export const vatRatesInitialState: VatRatesState = {
  vatRatesStatus: "IDLE",
  vatRates: [],
  vatRatesOptions: [],
}

export function vatRatesReducer(
  state = vatRatesInitialState,
  action: VatRatesActionType
): VatRatesState {
  switch (action.type) {
    case VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_ATTEMPT:
    case VatRatesActionsEnum.GET_COMPANY_VAT_RATES_ATTEMPT: {
      return { ...state, vatRatesStatus: "LOADING" }
    }
    case VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_SUCCESS:
    case VatRatesActionsEnum.GET_COMPANY_VAT_RATES_SUCCESS: {
      const options = action.vatRates.map((e) => {
        return { value: String(e.id), label: e.rate + "%" }
      })
      return {
        ...state,
        vatRatesStatus: "SUCCESS",
        vatRates: [...action.vatRates],
        vatRatesOptions: [...options],
      }
    }

    case VatRatesActionsEnum.GET_FIDUCIARY_VAT_RATES_ERROR:
    case VatRatesActionsEnum.GET_COMPANY_VAT_RATES_ERROR: {
      return { ...state, vatRatesStatus: "ERROR" }
    }

    default:
      return { ...state }
  }
}

export const getCompanyVatRatesThunk =
  (companyId: number, invoicing: boolean = false) =>
  (dispatch: Dispatch<VatRatesActionType>) => {
    dispatch(getCompanyVatRatesAttemptAction())
    return axios
      .get<VatRatesResponse>(`/companies/${companyId}/get_vat_rates`, {
        params: { invoicing },
      })
      .then((res) => {
        dispatch(getCompanyVatRatesSuccessAction(res.data.vat_rates))
      })
      .catch(() => {
        dispatch(getCompanyVatRatesErrorAction())
      })
  }

export const getFiduciaryVatRatesThunk =
  (fiduciaryId: number, invoicing: boolean = false) =>
  (dispatch: Dispatch<VatRatesActionType>) => {
    dispatch(getFiduciaryVatRatesAttemptAction())
    return axios
      .get<VatRatesResponse>(`/fiduciaries/${fiduciaryId}/get_vat_rates`, {
        params: { invoicing },
      })
      .then((response) => {
        dispatch(getFiduciaryVatRatesSuccessAction(response.data.vat_rates))
      })
      .catch((e) => {
        dispatch(getFiduciaryVatRatesErrorAction())
      })
  }
